import { useRecoilValue, useSetRecoilState } from "recoil";
import { AlternativeAutoComplete } from "../../../../component/form/autoComplete/_alternativeAutoComplete";
import { deliveryInfoState } from "state";
import StringUtils from "utils/string";
import { useEffect, useState } from "react";
import ArrayUtils from "utils/array";
import { transformAddressData } from "utils/transform";
import ValidateMessage from "./ValidateMessage";
import "./style.scss"

export default function DeliveryProvince() {
  const cartAddress = useRecoilValue(deliveryInfoState);
  const setCartAddress = useSetRecoilState(deliveryInfoState);
  const { province, ward } = cartAddress;

  const [keyword, setKeyword] = useState("");
  const [touch, setTouch] = useState(false)
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    setTouch(true)
  }

  const handleChange = (data) => {
    const childList = ArrayUtils.getQualifiedArray(data?.list).map(
       transformAddressData
    );
    setCartAddress({
      ...cartAddress,
      province: {
        ...cartAddress.province,
        value: data,
        validate: ''
      },
      ward: {
        value: null,
        listOrigin: childList,
        list: childList,
      },
    });
  };

  const handleKeywordChange = (data) => {
    if (keyword === data.value) return;

    const keywordInput = data.value || "";
    const formatDataValue = keywordInput
      ? StringUtils.removeAcent(keywordInput.toLowerCase())
      : "";

    const listData = province.listOrigin.filter((item) => {
      const formatNameItem = item?.name
        ? StringUtils.removeAcent(item.name.toLowerCase())
        : "";
      if (formatNameItem.includes(formatDataValue.trim())) return true;
      return false;
    });
    setKeyword(keywordInput);
    setCartAddress({
      ...cartAddress,
      province: {
        ...cartAddress.province,
        list: listData,
      }
    });
  };

  useEffect(() => {
    setCartAddress({
      ...cartAddress,
      province: {
        ...cartAddress.province,
        validate: touch && !open && !province?.value?.value ? 'Tỉnh/Thành phố không được để trống' : ''
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open ,touch]);

  return (
    <div>
      <AlternativeAutoComplete
        // main input
        className={"store-update_input-edit"}
        inputProps={{
          categoryList: [], // menu list in category dropdown
          categoryValue: { name: "Tỉnh/Thành phố", value: "" }, // if not exist this value -> default category: categoryList[0]
          categoryHidden: true,

          placeholder: "Chọn Tỉnh/Thành phố",
          readOnly: true,
          value: province.value?.name || "",
          onClick: handleOpen,
          validateText: province.validate,
          validateType: 'danger',
          validateClass: 'hidden'
        }}
        // search menu dropdown
        menuProps={{
          empty:
            province?.list?.length <= 0 ? "Không tìm thấy Tỉnh/Thành phố" : "",
        }}
        // search input in dropdown menu
        searchInputProps={{
          placeholder: "Tìm kiếm Tỉnh/Thành phố",
          value: keyword || "",
          onChange: handleKeywordChange,
        }}
        onBackdrop={() => setOpen(false)}
      >
        {province?.list?.length > 0 &&
          province?.list.map((item) => (
            <div
              className="auto-complete__option card-filter-form__option-text"
              key={item.value}
              data-active={item.value === province.value?.value}
              onClick={() => handleChange(item)}
            >
              {item.name}
            </div>
          ))}
      </AlternativeAutoComplete>
      <ValidateMessage>{province.validate}</ValidateMessage>
    </div>
  );
}
